/**
 * Formats a date value (String or Array) into a consistent IST string.
 * Handles Java LocalDateTime arrays [2025, 1, 26, 10, 30] and ISO Strings.
 */
export const formatDate = (val) => {
  if (!val) return 'N/A';

  // Handle Array format from Java [yyyy, MM, dd, HH, mm, ss]
  if (Array.isArray(val)) {
    const [y, m, d, h, min, s] = val;
    // Treat numbers as UTC
    return new Date(Date.UTC(y, m - 1, d, h || 0, min || 0, s || 0))
      .toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' }) + ' (IST)';
  }

  // Handle String format
  if (typeof val === 'string') {
    // If string doesn't have 'Z' or offset, append 'Z' to treat as UTC
    const timeString = val.endsWith('Z') || val.includes('+') ? val : val + 'Z';
    const dObj = new Date(timeString);
    return isNaN(dObj)
      ? 'N/A'
      : dObj.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' }) + ' (IST)';
  }

  return 'N/A';
};